module.exports = __webpack_public_path__ + "media/images/gallery/gc_on-0ac9af416af7f920189acb945256948f.gif";